export default __webpack_public_path__ + "static/media/address-details.a76237e3.svg";